// Глобальный кеш корзины для всех компонентов - предотвращает дублирование запросов
(function() {
  'use strict';
  
  const cache = {
    data: null,
    time: 0,
    ttl: 5000, // 5 секунд
    fetching: false,
    pending: [],
    
    async get() {
      const now = Date.now();
      
      // Проверяем кеш
      if (this.data && (now - this.time) < this.ttl) {
        return Promise.resolve(this.data);
      }
      
      // Если уже идет запрос - ждем его
      if (this.fetching) {
        return new Promise(resolve => {
          this.pending.push(resolve);
        });
      }
      
      // Делаем запрос
      this.fetching = true;
      return fetch('/cart.js')
        .then(res => res.json())
        .then(cart => {
          this.data = cart;
          this.time = now;
          this.fetching = false;
          
          // Разрешаем все ожидающие промисы
          this.pending.forEach(resolve => resolve(cart));
          this.pending = [];
          
          return cart;
        })
        .catch(err => {
          this.fetching = false;
          this.pending.forEach(resolve => resolve(null));
          this.pending = [];
          throw err;
        });
    },
    
    invalidate() {
      this.data = null;
      this.time = 0;
    },
    
    set(cart) {
      // Обновляем кеш напрямую
      this.data = cart;
      this.time = Date.now();
      
      // Разрешаем все ожидающие промисы
      this.pending.forEach(resolve => resolve(cart));
      this.pending = [];
      this.fetching = false;
    }
  };
  
  // Экспортируем в window для глобального доступа
  window.cartCache = cache;
  
  // Упрощенный глобальный метод для получения корзины
  window.getCart = async function() {
    return await cache.get();
  };
  
  // Упрощенный метод для установки корзины
  window.setCart = function(cart) {
    cache.set(cart);
  };
})();

